
export default {
  props: {
    slice: {
      type: Object,
      default: Function,
    },
  },
}
